import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { class: "content text-truncate" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "input-items" }
const _hoisted_5 = ["value", "checked"]
const _hoisted_6 = { class: "input-items" }
const _hoisted_7 = ["value", "checked"]

import ObjectHelper from "~/ts/library/ObjectHelper";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import {ICheckboxField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import ChatHtmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import ChatFormInlineSvgIcon from "~/chat/vue/widget/form/fields/ChatFormInlineSvgIcon.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed, nextTick, ref, watch} from "vue";
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
//import Multiselect from './VueMultiselect/Multiselect.vue'



const __default__ = {
    name: "ChatCheckboxInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps<ICheckboxField>()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

__expose(exposedObject);

let localValue = ref<string[]>();

let isModalOpened = ref(false);

function openModal() {
    isModalOpened.value = true;
}

function updateLocalValue(isNew?: boolean) {
    let value: any = null;
    if (props.modelValue) {
        value = ObjectHelper.jsonClone(props.modelValue);
    } else {
        if (isNew) {
            let defaultValues = props.field.options.filter(item => item.default).map(item => item.value);
            if (defaultValues.length) {
                nextTick(() => emits("update:modelValue", defaultValues));
            }
        }
    }
    localValue.value = value;
}

function isChecked(value: any) {
    return localValue.value && localValue.value.indexOf(value) > -1;
}

function onInput(e: any) {
    let target: HTMLInputElement = e.target;
    toggleItem(target.value, target.checked);
}

function toggleItem(itemValue: any, checked: boolean) {
    let value = localValue.value ? localValue.value : [];

    if (toggleArrayElement(value, itemValue, checked)) {
        emits("update:modelValue", value.length ? ObjectHelper.jsonClone(value) : null);
    }
}

watch(computed(() => props.modelValue), () => updateLocalValue());

updateLocalValue(true);

/*
let multiselectOptions = computed(() => {
    return props.field.options.map(option => option.value);
})
*/


return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'like-input': true,
            error: _ctx.error
        }),
    onClick: openModal
  }, [
    (_unref(props).field.options.length > 7)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", null, [
            _createVNode(ChatFormInlineSvgIcon, { field: _ctx.field }, null, 8, ["field"]),
            _createTextVNode(" " + _toDisplayString(_unref(placeholder)) + " ", 1),
            (_unref(localValue) && _unref(localValue).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(localValue), (item, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "tag"
                    }, [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(item), 1),
                      _createElementVNode("div", {
                        class: "remove",
                        onClick: _withModifiers(($event: any) => (toggleItem(item, false)), ["stop"])
                      }, [
                        _createVNode(SvgIcon, { "icon-name": "times" })
                      ], 8, _hoisted_3)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _withDirectives((_openBlock(), _createBlock(ChatModalMessage, {
            visible: _unref(isModalOpened),
            "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isModalOpened) ? (isModalOpened).value = $event : isModalOpened = $event)),
            title: _ctx.field.placeholder,
            "show-close-in-title": false,
            "without-padding": "",
            "show-close-in-footer": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.options, (item, index) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: index,
                    class: "cursor-pointer"
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      value: item.value,
                      checked: isChecked(item.value),
                      onChange: onInput
                    }, null, 40, _hoisted_5),
                    _createVNode(ChatHtmlify, {
                      links: "",
                      value: item.descr
                    }, null, 8, ["value"])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["visible", "title"])), [
            [
              _directive_on_native,
              void 0,
              "click",
              { stop: true }
            ]
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", null, [
            _createVNode(ChatFormInlineSvgIcon, { field: _ctx.field }, null, 8, ["field"]),
            _createTextVNode(" " + _toDisplayString(_unref(placeholder)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.options, (item, index) => {
              return (_openBlock(), _createElementBlock("label", {
                key: index,
                class: "cursor-pointer"
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  value: item.value,
                  checked: isChecked(item.value),
                  onChange: onInput
                }, null, 40, _hoisted_7),
                _createVNode(ChatHtmlify, {
                  links: "",
                  value: item.descr
                }, null, 8, ["value"])
              ]))
            }), 128))
          ])
        ], 64))
  ], 2))
}
}

})